import { type ComputedRef, computed, ref } from "vue";

export const usePaginatedData = <T>(data: ComputedRef<T[]>) => {
  const currentPage = ref(1);
  const itemsPerPage = ref(15);

  const metadata = computed(() => ({
    current_page: currentPage.value,
    from: currentPage.value * itemsPerPage.value - itemsPerPage.value + 1,
    to: currentPage.value * itemsPerPage.value,
    last_page: Math.ceil(data.value.length / itemsPerPage.value),
    path: "",
    per_page: itemsPerPage.value,
    total: data.value.length,
  }));

  const perPageData = computed(() =>
    data.value.slice(metadata.value.from - 1, metadata.value.to)
  );

  const handlePageChange = (page: number) => (currentPage.value = page);

  const handleItemsPerPageChange = (perPage: number) => {
    currentPage.value = 1;
    itemsPerPage.value = perPage;
  };

  return {
    currentPage,
    itemsPerPage,
    metadata,
    perPageData,
    handlePageChange,
    handleItemsPerPageChange,
  };
};
